import * as _ from 'lodash-es';
import * as CONST from './constants';
import * as UTIL from './utils';

const raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame;

const cancelAnim =
  window.cancelAnimationFrame || window.webkitCancelAnimationFrame;

export function morph(FD, TD, index) {
  const fromPathD = UTIL.getPathD({ dots: FD.dots[index], xs: FD.xs });
  const toPathD = UTIL.getPathD({ dots: TD.dots[index], xs: TD.xs });

  const getBoostedPath = (larger, smaller) => {
    const pathSemiDiff = Math.floor(
      Math.abs(fromPathD.length - toPathD.length) / 4
    );
    const firstFakerPoint =
      larger.length > smaller.length ? smaller[1] : larger[1];
    const lastFakerPoint =
      larger.length > smaller.length
        ? smaller[smaller.length - 1]
        : larger[larger.length - 1];
    let bamboozledPath = smaller.concat(
      new Array(pathSemiDiff).fill(`L ${lastFakerPoint}`)
    );

    bamboozledPath[0] = 'M'
      .concat(firstFakerPoint + ' ')
      .concat(new Array(pathSemiDiff).fill(`L 0,0`).join(' '));

    return bamboozledPath;
  };

  const ohManYouWereBamboozled =
    fromPathD.length > toPathD.length
      ? getBoostedPath(fromPathD, toPathD)
      : getBoostedPath(toPathD, fromPathD);

  return fromPathD.length > toPathD.length
    ? [fromPathD, ohManYouWereBamboozled].map((arr) => arr.join(' '))
    : [ohManYouWereBamboozled, toPathD].map((arr) => arr.join(' '));
}

export function animatePath(elem: any, from, to) {
  var animateMotion = document.createElementNS(CONST.NS.svg, 'animate');

  animateMotion.setAttribute('dur', UTIL.getVar('--anim-dur') + 'ms');
  animateMotion.setAttribute('repeatCount', '1');
  animateMotion.setAttribute('attributeName', 'd');
  animateMotion.setAttribute('begin', 'indefinite');
  animateMotion.setAttribute('calcMode', 'spline');
  animateMotion.setAttribute('keySplines', [0.47, 0, 0.745, 0.715].join(' '));
  animateMotion.setAttribute('from', from);
  animateMotion.setAttribute('to', to);

  elem.appendChild(animateMotion);

  try {
    const animateble: any = animateMotion;

    animateble.beginElement();
  } catch {}

  setTimeout(() => {
    elem.setAttribute('d', to);
    animateMotion.remove();
  }, parseInt(UTIL.getVar('--anim-dur')));
}

export function animateCSS(
  element: Element | string,
  animationName: string,
  callback?: () => void
) {
  const node =
    typeof element === 'string' ? document.querySelector(element) : element;

  node.classList.add('animated', animationName);

  function handleAnimationEnd() {
    node.classList.remove('animated', animationName);
    node.removeEventListener('animationend', handleAnimationEnd);

    callback && callback();
  }

  node.addEventListener('animationend', handleAnimationEnd);
}

export function animLoop(render, el) {
  var running,
    lastFrame = +new Date();

  const loop = (now) => {
    if (running !== false) {
      el.dataset.rafID && cancelAnim.call(window, el.dataset.rafID);
      const rafID = raf ? raf(loop) : setTimeout(loop, 16); // fallback to setTimeout
      el.dataset.rafID = rafID;
      now = now && now > 1e4 ? now : +new Date();
      var deltaT = now - lastFrame;
      if (Math.abs(deltaT) < 160) {
        running = render(deltaT, now);
      }
      lastFrame = now;
    }
  };

  loop(lastFrame);
}

export function animToVal(el, styleObj, cb) {
  const step = 1; // TODO eq steps like in matrix
  let attrVal = 0;

  Object.keys(styleObj).forEach((attrName) => {
    animLoop((deltaT: number, now: number) => {
      el.style[attrName] = (attrVal += (step * deltaT) / 6) + 'px';

      if (attrVal >= styleObj[attrName]) {
        el.style[attrName] = styleObj[attrName] + 'px';
        cb(el.dataset.rafID, now);
        cancelAnim(el.dataset.rafID);
        return false;
      }
    }, el);
  });
}

export function animToMatrix(el, matrix, cb?) {
  let indexesPassed = [];

  // const elOwn = el.ownerSVGElement;
  // const elPoint = elOwn.createSVGPoint()
  // const svgTransform = el.transform.baseVal.appendItem(
  //   el.ownerSVGElement.createSVGTransform()
  // );

  const initVal = el.getAttribute('transform')
    ? el
        .getAttribute('transform')
        .replace('matrix(', '')
        .replace(')', '')
        .split(' ')
        .map((i) => parseFloat(i))
    : [0, 0, 0, 0, 0, 0];

  const initialized = initVal;
  const resulted = matrix;

  if (_.isEqual(initialized, resulted)) {
    return;
  }

  const steps = matrix.map((i, idx) =>
    i === 0
      ? 0
      : Math.abs((initialized[idx] - i) / ([3].includes(idx) ? 8 : 2)) *
        (initialized[idx] < resulted[idx] ? 1 : -1)
  );

  animLoop((deltaT: number, now: number) => {
    el.setAttribute(
      'transform',
      `matrix(${matrix
        .map((i, idx) => {
          if (
            steps[idx] !== 0 &&
            ((initialized[idx] < resulted[idx] &&
              resulted[idx] > initVal[idx] + steps[idx]) ||
              (initialized[idx] > resulted[idx] &&
                resulted[idx] < initVal[idx] + steps[idx]))
          ) {
            initVal[idx] += steps[idx];
          } else {
            !indexesPassed.includes(idx) && indexesPassed.push(idx);
            initVal[idx] = resulted[idx];
          }

          return initVal[idx];
        })
        .join(' ')})`
    );

    if (indexesPassed.length === matrix.length) {
      cb && cb(el.dataset.rafID, now);
      cancelAnim(el.dataset.rafID);
      el.dataset.rafID = '';

      return false;
    }
  }, el);
}
